import { FC } from 'react';

import { NavBar } from 'common/components';
import AppLayout from 'common/components/layouts/app-layout';
import CustomHeader from 'common/components/layouts/custom-header/custom-header';
import { translate } from 'common/config/i18n';
import { useAppSelector } from 'common/helpers/hooks';
import { getPaymentLinkDetails, getPaymentLinkOwner } from 'common/store/payment-link';

const PaymentLinkLayout: FC = ({ children }) => {
  const paymentLinkDetails = useAppSelector(getPaymentLinkDetails);
  const owner = useAppSelector(getPaymentLinkOwner);

  return (
    <AppLayout CustomNavBar={PaymentLinkNavBar}>
      <CustomHeader
        title="AstroPay OneTouch - Payment Link"
        description={translate('payment_link_complete', {
          amount: `${paymentLinkDetails.currency} ${paymentLinkDetails.amount}`,
          userName: owner?.name,
        })}
      />
      {children}
    </AppLayout>
  );
};

const PaymentLinkNavBar: FC = () => {
  return <NavBar />;
};

export default PaymentLinkLayout;
